import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import { Grid, OutlinedInput, TableBody, TableCell, TableHead, TableRow, Select, MenuItem, FormControl } from '@material-ui/core';

import axiosInstance, { WEB_API, EVENT_ID } from '../constatns';
import Pagination from '../common/Pagination';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import Table from '../components/Table/Table';
import CircularProgress from '@material-ui/core/CircularProgress';

const moment = require('moment');
const styles = () => ({
  circle: {
    stroke: 'url(#linearColors)',
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#F4F5F9',
    color: theme.palette.primary.main,
    borderRight: '1px solid rgba(0, 0, 0, 0.1)',

    '&:nth-last-child(1)': {
      borderRight: 'none',
    },
  },
  body: {
    fontSize: 14,
    borderRight: '1px solid rgba(0, 0, 0, 0.1)',
    '&:nth-last-child(1)': {
      borderRight: 'none',
    },
  },
}))(TableCell);

class Bbs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bbsData: [],
      currentPage: 1,
      bbsPerPage: 5,
      filterBy: 'tc',
      search: '',
      loading: true,
    };
    this.goToPage = this.goToPage.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.changePage = this.changePage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.filterBbs = this.filterBbs.bind(this);
    this.strip = this.strip.bind(this);
  }

  componentDidMount() {
    if (
      window.screen.width < 500 ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      this.setState({ matches: true });
    } else {
      this.setState({ matches: false });
    }

    this.getNoticeList();
  }

  componentWillUnmount() {}

  goToPage(_move) {
    this.props.history.push(_move);
  }

  getNoticeList() {
    axiosInstance
      .get(`${WEB_API}/bbs/list?eventId=${EVENT_ID}`)
      .then((response) => {
        // convert string to Number
        response.data.Items.forEach((item) => {
          if (typeof item.sortOrder === 'string') {
            item.sortOrder = Number(item.sortOrder);
          }
        });

        response.data.Items.sort((a, b) => {
          return Number(b.sortOrder) - Number(a.sortOrder);
          // return Number(a.sortOrder) > Number(b.sortOrder) ? 1 : -1;
        });
        this.setState({ bbsData: response.data.Items, fullData: response.data.Items, loading: false });
        // console.log(this.state.fullData);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleClick(event) {
    this.setState({
      currentPage: Number(event.target.id),
    });
  }

  changePage(event, type) {
    if (type === 'prev') {
      if (this.state.currentPage > 1) {
        this.setState({
          currentPage: this.state.currentPage - 1,
        });
      }
    } else {
      if (this.state.currentPage < Math.ceil(this.state.bbsData.length / this.state.bbsPerPage)) {
        this.setState({
          currentPage: this.state.currentPage + 1,
        });
      }
    }
  }

  changeState = (newState) => {
    this.setState((prevState) => ({
      pageState: newState,
    }));
  };

  setDetail = (newVal) => {
    axiosInstance
      .get(`${WEB_API}/bbs/info?eventId=${EVENT_ID}&bbsId=${newVal.id}`) //조회수 +1
      .then((response) => {
        this.setState({ notiItems: newVal }, () => {
          this.props.history.push({
            pathname: '/bbs_detail',
            search: '?' + newVal.id,
          });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  strip(html) {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    // console.log(doc.body.textContent || '');
    return doc.body.textContent || '';
  }

  filterBbs(type, e) {
    this.setState({ [type]: e.target.value }, () => {
      let search = this.state.search.toLowerCase(); // 검색어
      let filterBy = this.state.filterBy; // 제목+내용 || 제목 || 내용
      this.setState({
        //eslint-disable-next-line
        bbsData: this.state.fullData.filter((el) => {
          /*내용이 string형태가 아닌 html형태일 경우 사용하면됨. */
          // let stripedContents = this.strip(el.bbsContents);
          if (filterBy === 'tc') {
            // 제목+내용 필터링
            if (el.bbsTitle || el.bbsContents) {
              return el.bbsTitle.toLowerCase().includes(search) || el.bbsContents.toLowerCase().includes(search);
            } else {
              return false;
            }
          } else if (filterBy === 'title') {
            // 제목만 필터링
            if (el.bbsTitle) {
              return el.bbsTitle.toLowerCase().includes(search);
            } else {
              return false;
            }
          } else if (filterBy === 'content') {
            // 내용만 필터링
            if (el.bbsContents) {
              return el.bbsContents.toLowerCase().includes(search);
            } else {
              return false;
            }
          }
        }),
      });
    });
  }

  bbsCnt = () => {
    // let counter = 0;
    // this.state.bbsData.forEach((data) => {
    //   if (data.sortOrder >= 0) {
    //     counter++;
    //   }
    // });
    return this.state.bbsData.length;
  };

  render() {
    const { classes } = this.props;
    const { bbsData, currentPage, bbsPerPage } = this.state;
    const indexOfLastTodo = currentPage * bbsPerPage;
    const indexOfFirstTodo = indexOfLastTodo - bbsPerPage;
    const currentbbsData = bbsData.slice(indexOfFirstTodo, indexOfLastTodo);

    // console.log(this.state.bbsData);

    const mapToComponent = (datas) =>
      //eslint-disable-next-line
      datas.map((row, idx) => {
        if (typeof row.sortOrder === 'number') {
          return (
            <TableRow
              key={idx}
              onClick={() => {
                this.setDetail(row);
              }}
              style={{ cursor: 'pointer' }}
            >
              <StyledTableCell scope="row" align="center" style={{ width: '7%' }}>
                {Number(row.sortOrder) >= 100 ? 'Notice' : Number(row.sortOrder)}
              </StyledTableCell>
              <StyledTableCell style={{ width: '62%' }}>{row.bbsTitle}</StyledTableCell>
              <StyledTableCell align="center" style={{ width: '10%' }}>
                {row.hit}
              </StyledTableCell>
              <StyledTableCell align="center" style={{ width: '16%' }}>
                {moment(Number(row.createdAt)).format('YYYY-MM-DD')}
              </StyledTableCell>
            </TableRow>
          );
        }
      });

    return (
      <React.Fragment>
        <CssBaseline />
        <Topbar MIdx={0} SIdx={3} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>News & Notice</MainTitle>
            </Grid>
            <Grid item xs={8} style={{ height: '22.5vw' }}>
              {this.state.search === '' ? (
                <p style={{ marginBottom: '10px' }}>
                  *Total Notice: <span style={{ color: '#aacb3c', fontWeight: 'bold' }}>{this.bbsCnt()}</span>
                </p>
              ) : (
                <p style={{ width: '0.1em', height: '1.429em', marginBottom: '10px' }} />
              )}
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center" width="7%">
                      No
                    </StyledTableCell>
                    <StyledTableCell align="center" width="62%">
                      Title
                    </StyledTableCell>
                    <StyledTableCell align="center" width="10%">
                      Hits
                    </StyledTableCell>
                    <StyledTableCell align="center" width="16%">
                      Date
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{currentbbsData && mapToComponent(currentbbsData)}</TableBody>
              </Table>
              {/* {currentbbsData.length > 0 ? (
                  ''
                ) : (
                  <div style={{ textAlign: 'center', color: '#d52121', padding: '10px' }}>
                    <b>등록된 게시물이 없습니다.</b>
                  </div>
                  )} */}
            </Grid>
            <Grid container justifyContent="center" style={{ height: '60px', marginBottom: '20px' }}>
              <Pagination
                bbsData={this.state.bbsData}
                currentPage={this.state.currentPage}
                bbsPerPage={this.state.bbsPerPage}
                handleClick={this.handleClick}
                changePage={this.changePage}
              />
            </Grid>
            <Grid
              container
              item
              xs={11}
              md={8}
              justifyContent="center"
              alignItems="center"
              style={{ backgroundColor: '#f4f4f4', padding: '10px 0' }}
            >
              <FormControl variant="outlined" size={'small'} style={{ width: '125px', marginRight: '10px', backgroundColor: '#fff' }}>
                <Select required value={this.state.filterBy} onChange={(e) => this.filterBbs('filterBy', e)}>
                  <MenuItem value="tc">제목+내용</MenuItem>
                  <MenuItem value="title">제목</MenuItem>
                  <MenuItem value="content">내용</MenuItem>
                </Select>
              </FormControl>
              <OutlinedInput
                className={classes.OutlinedInput}
                style={{ height: '40px', backgroundColor: '#fff' }}
                onChange={(e) => {
                  this.filterBbs('search', e);
                }}
                placeholder="검색어를 입력하세요"
              />
            </Grid>
          </Grid>
          {this.state.loading && (
            <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-15%, -50%)', zIndex: 9999 }}>
              <CircularProgress size={100} thickness={3} classes={{ circle: classes.circle }} style={{ opacity: 0.7 }} />
              <svg>
                <linearGradient id="linearColors">
                  <stop offset="20%" stopColor={'#237a9d'} />
                  <stop offset="80%" stopColor={'#aacb3c'} />
                </linearGradient>
              </svg>
            </div>
          )}
        </Container>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(Bbs));
